import React from 'react';
/**
 * This component will make sure that coords are updated in formik
 * state when a position is received or changed.
 */
const InputLatLng = ({ formik, handleChange, coords }) => {
  React.useEffect(
    function updateCoords() {
      if (coords) {
        formik.setFieldValue('lat', coords.latitude);
        formik.setFieldValue('lng', coords.longitude);
      }
    },
    [coords]
  );
  return (
    <>
      <input
        id="inputLat"
        onChange={handleChange}
        type="hidden"
        name="lat"
        value={formik.values.lat}
      />
      <input
        id="inputLng"
        onChange={handleChange}
        type="hidden"
        name="lng"
        value={formik.values.lng}
      />
    </>
  );
};

export default InputLatLng;
